module.exports = __webpack_public_path__ + "static/media/standart.4f77edda.jpg";